'use client';

import React__default, { useContext } from 'react';
import { ELanguage } from '../../Utils/constants.js';
import { EStep } from '../type.js';
import { initFormData } from '../const.js';

var initState = {
    hash: "#".concat(EStep.Welcome),
    setHash: function () { },
    lang: ELanguage.VI,
    accessToken: '',
    baseUrl: '',
    baseMsUrl: '',
    baseImageUrl: '',
    jobLevels: [],
    countries: [],
    cities: [],
    districts: {},
    categories: [],
    industries: [],
    user: null,
    formResumeInfo: initFormData,
    setFormResumeInfo: function () { },
    resumeType: 'attachCV',
    setResumeType: function () { },
    fileInfo: {},
    setFileInfo: function () { },
    isLoading: false,
    setIsLoading: function () { }
};
var OnBoardingContext = React__default.createContext(initState);
var useOnBoarding = function () { return useContext(OnBoardingContext); };

export { OnBoardingContext, initState, useOnBoarding };
//# sourceMappingURL=index.js.map
